import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Container,
  Header,
  SpaceBetween,
  FormField,
  Input,
  Textarea,
  BreadcrumbGroup,
  Autosuggest,
} from '@cloudscape-design/components';
import { useAuth } from 'react-oidc-context';
import { Layout } from '../../components/layout';
import { getEndpoint } from '../../utils';

export default function AddFAQ() {
  const auth = useAuth();
  const [section, setSection] = useState('');
  const [sections, setSections] = useState<string[]>([]);
  const [sectionValue, setSectionValue] = useState('');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(getEndpoint('/api/admin/sections'), {
          headers: {
            Authorization: `Bearer ${auth.user?.id_token}`,
          },
        });
        const data = await response.json();
        setSections(data.map((section: any) => section.PK.replace('FAQ#', '')));
      } catch (error) {
        console.error('Error fetching sections:', error);
      }
    };

    if (auth.isAuthenticated) {
      fetchSections();
    }
  }, [auth.isAuthenticated, auth.user?.id_token]);



  const handleSubmit = async () => {
    try {
      await fetch(getEndpoint('/api/admin/faq'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
        body: JSON.stringify({
          section,
          question,
          answer,
        }),
      });
      navigate('/admin/faq');
    } catch (error) {
      console.error('Error adding FAQ:', error);
    }
  };

  return (
    <Layout breadcrumbs={
      <BreadcrumbGroup
        items={[
          { text: "Admin", href: "/admin" },
          { text: "FAQs", href: "/admin/faq" },
          { text: "Add FAQ", href: "/admin/add-faq" },
        ]}
      />
    }>
      <SpaceBetween direction="vertical" size="l">
        <Header variant="h1">Add FAQ</Header>
        <Container>
          <SpaceBetween direction="vertical" size="l">
            <FormField label="Section">
              <Autosuggest
                value={sectionValue}
                onChange={({ detail }) => {
                  setSectionValue(detail.value);
                  setSection(detail.value);
                }}
                onSelect={({ detail }) => {
                  setSectionValue(detail.value);
                  setSection(detail.value);
                }}
                options={sections.map(section => ({ value: section }))}
                enteredTextLabel={value => `Use "${value}"`}
                placeholder="Enter a section name or select an existing one"
                empty="No matching sections found"
              />
            </FormField>
            <FormField label="Question">
              <Input
                value={question}
                onChange={({ detail }) => setQuestion(detail.value)}
              />
            </FormField>
            <FormField label="Answer">
              <Textarea
                value={answer}
                onChange={({ detail }) => setAnswer(detail.value)}
              />
            </FormField>
            <SpaceBetween direction="horizontal" size="xs">
              <Button onClick={() => navigate('/admin/faq')}>Cancel</Button>
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={!section || !question || !answer}
              >
                Add FAQ
              </Button>
            </SpaceBetween>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    </Layout>
  );
}
